"use client";

type EmailPreviewProps = {
	html: string;
};

export function EmailPreview({ html }: EmailPreviewProps) {
	return (
		<div className="border border-gray-200 rounded-lg overflow-hidden bg-gray-50">
			<div className="bg-gray-100 px-4 py-2 border-b border-gray-200 flex items-center gap-2">
				<div className="w-3 h-3 rounded-full bg-red-400" />
				<div className="w-3 h-3 rounded-full bg-yellow-400" />
				<div className="w-3 h-3 rounded-full bg-green-400" />
			</div>
			<div className="p-4 max-h-[600px] overflow-y-auto">
				<iframe
					srcDoc={html}
					title="Email preview"
					className="w-full h-[500px] bg-white rounded border-0"
					sandbox="allow-same-origin"
				/>
			</div>
		</div>
	);
}
